import * as studyService from "./study-service";
import * as featureNavigationService from "./feature-navigation-service";

const services = {
  ...studyService,
  ...featureNavigationService
};

export default services;
